/* ──────────────────────────────────────────
   DBD Collection — v8
   Brand toggle (Apple / Lenovo / future) swaps which brand's row of system
   cards is shown. Optional model dropdown narrows within the active brand.
   Tiers live on the product page.
   ────────────────────────────────────────── */
(function () {
  'use strict';

  // Models per brand — must match fit:* tag values. Add a brand here when you
  // start selling for it (same id used in the section's brand_ids).
  const FIT_MODELS = {
    apple: [
      { id: 'macbook-neo',           label: 'MacBook Neo' },
      { id: 'macbook-air-13-m2-m5',  label: 'MacBook Air 13" (M2–M5)' },
      { id: 'macbook-air-15-m2-m5',  label: 'MacBook Air 15" (M2–M5)' },
      { id: 'macbook-pro-13-m1-m2',  label: 'MacBook Pro 13" (M1–M2 / Intel 2019–2020)' },
      { id: 'macbook-pro-14-m1-m4',  label: 'MacBook Pro 14" (M1–M4)' },
      { id: 'macbook-pro-14-m5',     label: 'MacBook Pro 14" (M5)' },
      { id: 'macbook-pro-16-m1-m5',  label: 'MacBook Pro 16" (M1–M5)' },
    ],
    lenovo: [
      { id: 'lenovo-thinkpad-e14-gen6-7', label: 'ThinkPad E14 Gen 6/7' },
      { id: 'lenovo-thinkpad-e16-gen3',   label: 'ThinkPad E16 Gen 3' },
    ],
    microsoft: [
      { id: 'surface-laptop-7-8-13', label: 'Surface Laptop 13.8" (7th / 8th Gen)' },
    ],
  };

  const SK_BRAND = 'dbd:fit:brand';
  const SK_MODEL = 'dbd:fit:model';

  const root = document.querySelector('[data-dbd-col]');
  if (!root) return;

  const brandbar = root.querySelector('[data-dbd-brandbar]');
  const modelEl  = root.querySelector('[data-dbd-model]');
  const resetEl  = root.querySelector('[data-dbd-reset]');
  const countEl  = root.querySelector('[data-dbd-count]');
  const subEl    = root.querySelector('[data-dbd-sub]');
  const emptyEl  = root.querySelector('[data-dbd-empty="mounts"]');
  const SUB_DEFAULT = subEl ? subEl.textContent : '';

  const brandBtns = [].slice.call(root.querySelectorAll('.dbd-brandbtn'));

  // Safety: hide a brand toggle whose grid has no system cards (e.g. a brand
  // configured before its products exist), so we never show an empty brand.
  brandBtns.forEach(btn => {
    const g = root.querySelector('[data-dbd-brand-grid="' + btn.dataset.brand + '"]');
    if (!g || g.querySelectorAll('.dbd-card--system').length === 0) btn.hidden = true;
  });
  const liveBtns = brandBtns.filter(b => !b.hidden);
  if (!liveBtns.length) return;

  let activeBrand   = localStorage.getItem(SK_BRAND) || '';
  let selectedModel = localStorage.getItem(SK_MODEL) || '';
  if (!liveBtns.some(b => b.dataset.brand === activeBrand)) {
    activeBrand = liveBtns[0].dataset.brand;
    selectedModel = '';
  }

  function brandLabel(b) {
    const btn = brandBtns.find(x => x.dataset.brand === b);
    return btn ? btn.textContent.trim() : b;
  }
  function gridFor(b) { return root.querySelector('[data-dbd-brand-grid="' + b + '"]'); }

  function populateModels(brand) {
    modelEl.innerHTML = '';
    modelEl.appendChild(new Option('All models', ''));
    (FIT_MODELS[brand] || []).forEach(m => modelEl.appendChild(new Option(m.label, m.id)));
    modelEl.disabled = !(FIT_MODELS[brand] && FIT_MODELS[brand].length);
  }

  function apply() {
    // Show only the active brand's grid; sync toggle styling.
    root.querySelectorAll('[data-dbd-brand-grid]').forEach(g => {
      g.hidden = g.dataset.dbdBrandGrid !== activeBrand;
    });
    brandBtns.forEach(b => {
      const on = b.dataset.brand === activeBrand;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    const grid = gridFor(activeBrand);
    let total = 0, visible = 0;
    if (grid) {
      grid.querySelectorAll('.dbd-card--system').forEach(card => {
        total++;
        const fits = (card.dataset.fits || '').split(/\s+/).filter(Boolean);
        let show = true;
        if (selectedModel && !fits.includes(selectedModel)) show = false;
        card.hidden = !show;
        const fc = card.querySelector('[data-dbd-fit-chip]');
        if (fc) fc.hidden = !(show && selectedModel);
        if (show) visible++;
      });
    }

    if (emptyEl) emptyEl.hidden = visible > 0;
    if (countEl) countEl.textContent = selectedModel ? `${visible} of ${total} systems fit` : '';
    if (subEl) {
      if (selectedModel) {
        const all = Object.keys(FIT_MODELS).reduce((a, k) => a.concat(FIT_MODELS[k]), []);
        const m = all.find(x => x.id === selectedModel);
        subEl.textContent = m ? `Showing systems that fit ${m.label}.` : SUB_DEFAULT;
      } else {
        subEl.textContent = `${brandLabel(activeBrand)} laptops · every system uses the same SlideLink cable standard.`;
      }
    }
    if (resetEl) resetEl.hidden = !selectedModel;
  }

  function setBrand(b) {
    activeBrand = b;
    selectedModel = '';
    localStorage.setItem(SK_BRAND, b);
    localStorage.setItem(SK_MODEL, '');
    populateModels(b);
    modelEl.value = '';
    apply();
  }

  if (brandbar) brandbar.addEventListener('click', e => {
    const btn = e.target.closest('.dbd-brandbtn');
    if (!btn || btn.hidden) return;
    setBrand(btn.dataset.brand);
  });

  modelEl.addEventListener('change', e => {
    selectedModel = e.target.value;
    localStorage.setItem(SK_MODEL, selectedModel);
    apply();
  });

  if (resetEl) resetEl.addEventListener('click', () => {
    selectedModel = '';
    localStorage.setItem(SK_MODEL, '');
    modelEl.value = '';
    apply();
  });

  /* ── Init ── */
  populateModels(activeBrand);
  if (selectedModel) modelEl.value = selectedModel;
  apply();
})();
